import AddInactivityAlertModal from './containers/AddInactivityAlertModalContainer'

export default AddInactivityAlertModal
